<div class="wrap">
  <div class="color" [style.background-color]="'#' +selected?.value"></div>
  
  <mat-form-field appearance="outline">
    <mat-label>Couleur</mat-label>
    <mat-select [(value)]="selected" (valueChange)="updateColorTag( $event)">
      <mat-option *ngFor="let c of colors" [value]="c">
        <span> {{c.name}}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>